import _ from 'lodash';
import { computed, onMounted, onBeforeUnmount, ref } from 'vue';

export default function withMobileView(props) {
  const windowWidth = ref(0);
  const windowHeight = ref(0);
  windowWidth.value = window.innerWidth;

  // handleWindowResize responds to the user resizing the window by
  // resizing the window width.
  const handleWindowResize = (event) => {
    windowWidth.value = _.get(event, ['currentTarget', 'innerWidth']);
    if (_.isUndefined(windowWidth.value)) windowWidth.value = 0;
    windowHeight.value = _.get(event, ['currentTarget', 'innerHeight']);
    if (_.isUndefined(windowHeight.value)) windowHeight.value = 0;
  };

  onMounted(() => window.addEventListener('resize', handleWindowResize));
  onBeforeUnmount(() =>
    window.removeEventListener('resize', handleWindowResize));

  return {
    handleWindowResize,
    mobileView: computed(() => windowWidth.value < props.pixelWidthCutoff),
    windowHeight,
    windowWidth,
  };
}
